import Component from '../core/Component'
import Scroll from '../services/Scroll'
import withMedia from '../core/withMedia'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

class SectionObserver extends Component {
    constructor(element) {
        super(element, {
            media: 'xxlargeUp',
        })

        this.state = {
            sectionObserver: null,
            originAnchorTop: null,
            footerHeight: null
        }

        this.section = []

        this.sectionObserverOptions = {
            rootMargin: '-20% 0% -70% 0%',
            threshold: 0,
        };

        this.fixedAnchor = document.querySelector('.FixedAnchors')
        this.fixedAnchorList = document.querySelector('.FixedAnchors ul')
        this.fixedAnchorLinks = null
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        this.resize()

        this.state.originAnchorTop = document.querySelector('[data-ref="originAnchorList"]')?.getBoundingClientRect().top
        this.fixedAnchorList.innerHTML = document.querySelector('[data-ref="originAnchorList"]')?.innerHTML
        this.fixedAnchorLinks = document.querySelectorAll('.FixedAnchors a')
        this.fixedAnchorList.querySelectorAll('a').forEach(link => {
            const href = link.getAttribute('href').substring(1)
            link.setAttribute('data-link', href)
        })

        EventBus.on(EVENTS.SWUP_CLICK_LINK, () => {
            this.fixedAnchor.style.opacity = 0
        })

        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, () => {
            if(!document.querySelector('[data-ref="originAnchorList"]')) {
                return
            }
            this.state.originAnchorTop = document.querySelector('[data-ref="originAnchorList"]')?.getBoundingClientRect().top
            this.fixedAnchorList.innerHTML = document.querySelector('[data-ref="originAnchorList"]').innerHTML
            this.fixedAnchorLinks = document.querySelectorAll('.FixedAnchors a')
            this.fixedAnchorList.querySelectorAll('a').forEach(link => {
                const href = link.getAttribute('href').substring(1)
                link.setAttribute('data-link', href)
            })

            this.section = document.querySelectorAll('[data-section]')
            this.section.forEach(section => {
                this.state.sectionObserver.observe(section)
            })


            this.state.originAnchorTop = document.querySelector('[data-ref="originAnchorList"]')?.getBoundingClientRect().top

            this.fixedAnchor.style.transform = "translate(-50%, -100px)"
            this.fixedAnchor.style.opacity = 1
        })

        this.fixedAnchor.style.opacity = 1

        this.section = document.querySelectorAll('[data-section]')
        this.coloredSection = document.querySelectorAll('[data-colored]')

        this.state.sectionObserver = new IntersectionObserver(([section]) => {
            if (section.isIntersecting) {
                console.log(section.isIntersecting)
                this.fixedAnchorLinks.forEach(anchor => {
                    anchor.classList.remove('is-active')
                })
                this.fixedAnchorLinks.forEach(anchor => {
                    if(section.target.dataset.section === "remove") {
                        return
                    }
                    if(anchor.getAttribute("data-link").includes(section.target.id)) {
                        anchor.classList.add('is-active')
                    }
                })
            }
        }, this.sectionObserverOptions)

        this.section.forEach(section => {
            this.state.sectionObserver.observe(section)
        })
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize = () => {
        if(!document.querySelector('[data-ref="originAnchorList"]')) {
            return
        }

        setTimeout(() => {
            this.state.originAnchorTop = document.querySelector('[data-ref="originAnchorList"]')?.getBoundingClientRect().top
        }, 500)
        this.state.footerHeight = document.querySelector('.footer-Main')?.getBoundingClientRect().height
    }

    handleScroll = (event) => {
        if(!document.querySelector('[data-ref="originAnchorList"]')) {
            return
        }

        if(event.y < this.state.originAnchorTop + 100) {
            this.fixedAnchor.style.transform = "translate(-50%, -100px)"
        } else {
            if(event.y < event.limit.y - (this.state.footerHeight * 0.25)) {
                this.fixedAnchor.style.transform = "translate(-50%, 35px)"
            } else {
                this.fixedAnchor.style.transform = "translate(-50%, -100px)"
            }
        }

        if(event.y === 0) {
            if(!document.querySelector('[data-ref="originAnchorList"]')) {
                return
            }
            this.fixedAnchor.style.transform = "translate(-50%, -100px)"
        }
    }
}

export default withMedia(SectionObserver)